import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import PublicLayout from '@layout/PublicLayout';
import { GeneralContent } from '@layout/Layout.style';
import { useGeolocation } from '@hooks';
const SignDocumentsWithoutLocation = () => {
    const { getGeolocationStatus, getCurrentPosition } = useGeolocation();
    return (_jsx(PublicLayout, { children: _jsx(GeneralContent, { children: _jsx(Outlet, { context: { getGeolocationStatus, getCurrentPosition } }) }) }));
};
export default SignDocumentsWithoutLocation;
